/**
 * OriginalContentAck — required-checkbox gate for every upload form.
 *
 * Drop one of these above your submit button, wire `checked` + `onChange`,
 * and disable submit until `checked === true`. After a successful upload,
 * call `recordOriginalAck(contentId)` from `../utils/originalAck.js` so the
 * acknowledgement is stamped on the new content document for legal record.
 */
import React from 'react';
import { ShieldCheck } from 'lucide-react';

export const ORIGINAL_ACK_VERSION = 'v1';

export const ORIGINAL_ACK_STATEMENT =
  "I confirm this is my own original work, or I hold all the rights " +
  "needed to upload, distribute and monetise it on Smarter Learning Hub. " +
  "I will not upload AI-generated content I have not edited, copyrighted " +
  "material I don't own, or anything that violates someone else's rights.";

const OriginalContentAck = ({
  checked,
  onChange,
  disabled = false,
  testId = 'original-ack',
  className = '',
}) => (
  <label
    className={`flex items-start gap-2.5 p-3 sm:p-3.5 rounded-xl bg-amber-500/5 border border-amber-400/30 cursor-pointer hover:bg-amber-500/10 transition ${className}`}
    data-testid={testId}
  >
    <input
      type="checkbox"
      checked={!!checked}
      onChange={(e) => onChange?.(e.target.checked)}
      disabled={disabled}
      className="mt-0.5 h-4 w-4 shrink-0 rounded border-amber-400/60 bg-slate-900 text-amber-400 focus:ring-amber-400/50"
      data-testid={`${testId}-checkbox`}
      required
    />
    <span className="flex-1 text-[12px] sm:text-[13px] leading-snug text-amber-100/90">
      <span className="inline-flex items-center gap-1 text-amber-200 font-bold uppercase tracking-wider text-[10px] mr-1">
        <ShieldCheck className="w-3.5 h-3.5" /> Originality
      </span>
      {ORIGINAL_ACK_STATEMENT}
    </span>
  </label>
);

export default OriginalContentAck;
